import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold" }, "Typical uses", -1)
const _hoisted_3 = { class: "row-auto flex flex-col gap-2" }
const _hoisted_4 = { class: "flex flex-col gap-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", { class: "font-semibold" }, "Standard width", -1)
const _hoisted_6 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", { class: "font-semibold" }, "Alternative width", -1)
const _hoisted_8 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_9 = ["max"]
const _hoisted_10 = { class: "space-y-2" }

import { computed, ref, watch } from 'vue';

import { SidewalkPortion } from '@/composables/sidewalk-tradeoff';
import Box from '@/elements/box/Box';
import Input from '@/elements/inputs/Input.vue';
import Message from '@/components/message/Message.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Portion',
  props: {
  label: { type: String },
  maxWidth: { type: Number },
  portion: {
    type: Object as () => SidewalkPortion,
    required: true,
  },
},
  emits: ['changed'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const width = ref(props.portion.standardWidth);

const issues = computed(() =>
  props.portion.issues.filter(
    (i) => width.value >= i.minWidth && width.value < i.maxWidth
  )
);

watch(width, (newWidth: number) => {
  width.value = newWidth || 0;
  emit('changed', width.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Box), { as: "section" }, {
    default: _withCtx(() => [
      _createElementVNode("header", null, [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(__props.label), 1),
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(__props.portion.comment), 1)
      ]),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("dl", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("dd", _hoisted_6, _toDisplayString(__props.portion.standardWidth) + " feet ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("dd", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "range",
                id: "width",
                name: "width",
                min: "0",
                max: __props.maxWidth,
                step: "0.1",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((width).value = $event))
              }, null, 8, _hoisted_9), [
                [
                  _vModelText,
                  width.value,
                  void 0,
                  { number: true }
                ]
              ]),
              _createVNode(Input, {
                id: "width",
                name: "width",
                type: "number",
                min: "0",
                max: __props.maxWidth,
                step: "0.1",
                modelValue: width.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((width).value = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["max", "modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issues.value, (issue, index) => {
            return (_openBlock(), _createBlock(Message, {
              key: index,
              icon: "exclamation",
              color: "tangerine",
              variant: "light",
              summary: issue.comment
            }, null, 8, ["summary"]))
          }), 128)),
          (!issues.value || !issues.value.length)
            ? (_openBlock(), _createBlock(Message, {
                key: 0,
                icon: "check",
                color: "green",
                variant: "light",
                summary: "Meets standards"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})